import {
  Button,
} from "@mui/material";
import { useRef, useState } from "react";

import { CalendarPopup } from "~/components/common/calendar/CalendarPopup";
import ProviderSetOwnAvailability from "./ProviderSetOwnAvailability"
import PersonIcon from '@mui/icons-material/Person';
import PermissionOrHide from "~/components/common/PermissionOrHide";
import { Permission } from "~/hooks/permissions";
import { gql, useQuery } from "@apollo/client";
import { OrganizationUserRoleGlobalUserRoleEnum, ProviderRolesQuery } from "~/graphql/__generated__/graphql";
import { TransferListProps } from "~/components/common/forms/TransferList";

const ProviderAvailabiltyMenu = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const popoverEventElement = useRef<null | HTMLAnchorElement>(null);
  const closePopup = () => setOpenPopup(false);

  const { data } = useQuery<ProviderRolesQuery>(PROVIDER_ROLES_QUERY);

  const providers: TransferListProps["selected"] = {};

  data?.provider.forEach(provider => {
    if (!provider.OrganizationUser) { return; }

    const roles = provider.OrganizationUser.roles.map(r => r.globalUserRole).filter(r => r);

    providers[provider.OrganizationUser.id] = {
      label: `${provider.firstName} ${provider.lastName}${provider.firstName === provider.OrganizationUser?.user?.firstName ? '' : (' (' + provider.OrganizationUser?.user?.firstName + ')')}`,
      // The manageOwnAvailability permission is *NOT* granted to admins or developers;
      // it only comes from this one role. This makes it easy for devs to add or remove the role
      // from themselves to test different setups.
      selected: roles.includes(OrganizationUserRoleGlobalUserRoleEnum.SelfScheduleProvider),
    };
  });

  return <>
    <PermissionOrHide permission={Permission.toggleManageOwnAvailability}>
      <Button
        ref={popoverEventElement as any}
        onClick={() => setOpenPopup(true)}
        variant="outlined"
        size="small"
        color="info"
        endIcon={<PersonIcon />}
      >
        Manage Providers
      </Button>
    </PermissionOrHide>

    <CalendarPopup
      isOpen={openPopup}
      visitAnchor={popoverEventElement.current}
      onClose={closePopup}
    >
      {data && <ProviderSetOwnAvailability providers={providers} data={data} onClose={closePopup}/>}
    </CalendarPopup>
  </>;
}

export default ProviderAvailabiltyMenu;


export const PROVIDER_ROLES_QUERY = gql(`
  query ProviderRoles
  @permission(requires: manageProviderShifts)
  {
    provider(where: { active: { eq: true }}) {
      id
      firstName
      lastName
      OrganizationUser {
        id
        roles {
          globalUserRole
        }
        user {
          firstName
          lastName
        }
      }
    }
  }
`);
